export var StoryNodeState;
(function (StoryNodeState) {
    StoryNodeState["IDLE"] = "IDLE";
    StoryNodeState["LOADING"] = "LOADING";
    StoryNodeState["RECEIVING"] = "RECEIVING";
    StoryNodeState["COMPLETED"] = "COMPLETED";
    StoryNodeState["ERROR"] = "ERROR";
})(StoryNodeState || (StoryNodeState = {}));
